import { GraphsService } from './../services/graphs.service';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ScriptLoaderService } from 'src/app/script-loader.service';
import { PagesService } from '../page.service';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import moment from 'moment';

declare var $;
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit, AfterViewInit {
  cards;

  filterQuery: FilterQuery = {
    from: moment().subtract(1, 'w').format("YYYY-MM-DD"),
    to: moment().format("YYYY-MM-DD"),
    filter: 'day'
  }
  inquiriesStatus: any[];
  totalSales: any[];
  bookings: any[];
  visitors: any[];
  inquiries: any[];
  salesChannelBreakdown: any[];
  inquiryChannelBreakdown: any[];
  topLandingPages: any[];
  topExperiences: any[];
  inquiriesStatusTitle: string;
  totalSalesTitle: string;
  bookingsTitle: string;
  visitorsTitle: string;
  inquiriesTitle: string;
  salesChannelBreakdownTitle: string;
  inquiryChannelBreakdownTitle: string;
  topLandingPagesTitle: string;
  topExperiencesTitle: string;

  // Charts options
  view: any[] = [500, 250];
  colorScheme = {
    domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']
  };
  gradient: boolean = true;
  showLegend: boolean = true;
  showLabels: boolean = true;
  isDoughnut: boolean = false;
  legendPosition: string = 'right';
  showXAxis: boolean = true;
  showYAxis: boolean = true;
  showXAxisLabel: boolean = true;
  yAxisLabel: string = 'Sales';
  xAxisLabel: string = 'Date';
  showYAxisLabel: boolean = true;
  legend: boolean = true;
  animations: boolean = true;
  xAxis: boolean = true;
  yAxis: boolean = true;
  timeline: boolean = true;

  constructor(
    private loaderService: ScriptLoaderService,
    private dashboardService: PagesService,
    private graphsService: GraphsService
  ) {
    // tslint:disable-next-line: no-use-before-declare
    this.cards = new DashboardCardsModel();
  }

  ngOnInit() {
    this.getVisitors();
    this.getBook();
    this.getInquires();
    this.getTravelers();
    this.getInquiriesStatus();
    this.getVisitorsInquiries();
    this.getBookingsInquiries();
    this.getTravelersLTV();

    this.getInquiriesStatusGraph();
    this.getTotalSalesGraph();
    this.getInquiriesGraph();
    this.getBookingsGraph();
    this.getVisitorsGraph();
    this.getSalesChannelBreakdownGraph();
    this.getInquiryChannelBreakdownGraph();
    this.getTopLanding();
    this.getTopExperiences();
    window.scroll({
      top: 0,
      behavior: 'smooth',
    });
  }
  ngAfterViewInit() {
    this.loaderService.loadScripts('body', [
      'assets/js/pages/chart/chart-page-init.js',
    ]);
  }

  getBook() {
    this.dashboardService.getBookingsCount().subscribe((result) => {
      this.cards.book.title = result.data.title;
      this.cards.book.count = result.data.bookings;
    });
  }
  getVisitors() {
    this.dashboardService.getVisitorsCount().subscribe((result) => {
      this.cards.visitors.title = result.data.title;
      this.cards.visitors.count = result.data.visitors;
    });
  }
  getInquires() {
    this.dashboardService.getInquiriesCount().subscribe((result) => {
      this.cards.inquiries.title = result.data.title;
      this.cards.inquiries.count = result.data.inquiries;
    });
  }
  getTravelers() {
    this.dashboardService.getTravlersCount().subscribe((result) => {
      this.cards.travelers.title = result.data.title;
      this.cards.travelers.count = result.data.travelers;
    });
  }
  getInquiriesStatus() {
    this.dashboardService.getInquiresStatusCount().subscribe((result: any) => {
      this.cards.inquiriesStatus.title = result.data.title;
      let travelers: Array<any> = [];
      travelers = result.data.travelers;
      const length = travelers.length;
      if (length) {
      this.cards.inquiriesStatus.count = String(length);
    }

    });
  }
  getVisitorsInquiries() {
    this.dashboardService.getVisitorsInquiresCount().subscribe((result) => {
      this.cards.visitorsInquires.title = result.data.title;
      if (result.data.percentage) {
        this.cards.visitorsInquires.count = String(result.data.percentage);
      }

    });
  }
  getBookingsInquiries() {
    this.dashboardService.getBookingsInquiresCount().subscribe((result) => {
      this.cards.bookingInquires.title = result.data.title;
      if (result.data.percentage) {
        this.cards.bookingInquires.count = String(result.data.percentage);
      }

    });
  }
  getTravelersLTV() {
    this.dashboardService.getTravelersLTVCount().subscribe((result) => {
      this.cards.travelerLTV.title = result.data.title;
      if (result.data.LTV) {
        this.cards.travelerLTV.count = String(result.data.LTV);
      }

    });
  }

  //#region Graphs

  getTotalSalesGraph() {
    this.graphsService.getTotalSales(this.filterQuery).subscribe((result) => {
      this.totalSalesTitle = result.data[0]['name'];
      this.totalSales = result.data;
    });
  }

  getInquiriesStatusGraph() {
    this.graphsService.getInquiriesStatus(this.filterQuery).subscribe((result) => {
      this.inquiriesStatusTitle = result.data.title;
      this.inquiriesStatus = result.data.inquiriesStatus.series.map(i => ({
        name: i.status,
        value: i.count
      }))
    });
  }

  getInquiriesGraph() {
    this.graphsService.getInquiries(this.filterQuery).subscribe((result) => {
      this.inquiriesTitle = result.data[0]['name'];
      this.inquiries = result.data;
    });
  }

  getBookingsGraph() {
    this.graphsService.getBookings(this.filterQuery).subscribe((result) => {
      this.bookingsTitle = result.data[0]['name'];
      this.bookings = result.data;
    });
  }

  getVisitorsGraph() {
    this.graphsService.getVisitors(this.filterQuery).subscribe((result) => {
      this.visitorsTitle = result.data[0]['name'];
      this.visitors = result.data;
    });
  }

  getSalesChannelBreakdownGraph() {
    this.graphsService.getSalesChannelBreakdown(this.filterQuery).subscribe((result) => {
      this.salesChannelBreakdownTitle = result.data.title;
      this.salesChannelBreakdown = result.data.sales.map(i => ({
        name: i.reseller,
        value: i.sum
      }))
    });
  }

  getInquiryChannelBreakdownGraph() {
    this.graphsService.getInquiryChannelBreakdown(this.filterQuery).subscribe((result) => {
      this.inquiryChannelBreakdownTitle = result.data.title;
      this.inquiryChannelBreakdown = result.data.inquiries.map(i => ({
        name: i.reseller,
        value: i.count
      }))
    });
  }

  getTopLanding() {
    this.dashboardService.getTopLandingCount().subscribe((result) => {
      this.topLandingPagesTitle = result.data.title;
      this.topLandingPages = result.data.pages.map(i => ({
        name: i.path,
        value: i.count
      }));
    });
  }

  getTopExperiences() {
    this.dashboardService.getTopExperiencesCount().subscribe((result) => {
      this.topExperiencesTitle = result.data.title;
      this.topExperiences = result.data.experiences.map(i => ({
        name: i.name,
        value: i.count
      }));
    });
  }

  //#endregion Graphs
}

export class DashboardCardsModel {
  book: CardModel;
  visitors: CardModel;
  inquiries: CardModel;
  travelers: CardModel;
  inquiriesStatus: CardModel;
  visitorsInquires: CardModel;
  bookingInquires: CardModel;
  bookingVisitors: CardModel;
  travelerLTV: CardModel;

  constructor() {
    this.book = new CardModel();
    this.visitors = new CardModel();
    this.inquiries = new CardModel();
    this.travelers = new CardModel();
    this.inquiriesStatus = new CardModel();
    this.visitorsInquires = new CardModel();
    this.bookingInquires = new CardModel();
    this.bookingVisitors = new CardModel();
    this.travelerLTV = new CardModel();
  }
}

export class CardModel {
  title: string;
  count: string;

  constructor() {
    this.title = '';
    this.count = '';
  }
}

export class CardPagesModel {
  title: string;
  Pages: Pages[];

  constructor() {
    this.title = '';
    this.Pages = [];
  }
}
export class Pages {
  path: string;
  count: string;


  constructor() {
    this.path = '';
    this.count = '';
  }
}
export class CardExperiencesModel {
  title: string;
  experiences: Experience[];

  constructor() {
    this.title = '';
    this.experiences = [];
  }
}
export class Experience {
  name: string;
  count: string;


  constructor() {
    this.name = '';
    this.count = '';
  }
}

export interface FilterQuery {
  from: string;
  to: string;
  filter: string;
}